import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=f1212aaa&"
import script from "./empty.vue?vue&type=script&lang=js&"
export * from "./empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1212aaa')) {
      api.createRecord('f1212aaa', component.options)
    } else {
      api.reload('f1212aaa', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=f1212aaa&", function () {
      api.rerender('f1212aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/empty/empty.vue"
export default component.exports